export const companies = [
  {
    id: "confidential",
    name: "Confidential",
    category: "Digital Media / Social Publishing",
    founded: "2012",
    followers: "3.6M+",
    platform: "LinkedIn",
    tagline: "The professional world's most-followed independent media voice.",
    description:
      "Founded in 2012, Confidential grew from a single editorial channel into one of the largest independent business-media pages on LinkedIn, cultivating an audience of more than 3.6 million professionals worldwide. The brand publishes sharp commentary, market intelligence and long-form storytelling for founders, operators and investors — turning ideas into influence at global scale.",
    highlights: [
      "3.6M+ engaged professional followers",
      "Daily editorial & market commentary",
      "Founder, investor & operator audience",
      "Native-first social publishing since 2012",
    ],
    image:
      "https://images.unsplash.com/photo-1527576539890-dfa815648363?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2UlMjBhcmNoaXRlY3R1cmUlMjBibGFjayUyMGFuZCUyMHdoaXRlfGVufDB8fHx8MTc4NTYzMDAyM3ww&ixlib=rb-4.1.0&q=85",
    link: "https://www.linkedin.com/company/confidential-company-page12/",
    accent: "#E83D16",
  },
];

export default companies;
